var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect } from 'react';
import { useReducerAsync } from 'use-reducer-async';
import logger from '../../config/app.logger';
import { getExtendedLogger } from '../Logger';
import { getTranslations } from './helpers';
import { ActionTypes, LOGGER_NAME } from './constants';
var log = getExtendedLogger(LOGGER_NAME, logger);
var initialState = {
    loaded: false,
    loading: false,
    failed: false,
    language: 'en',
    translations: {},
};
function reducer(state, action) {
    switch (action.type) {
        case ActionTypes.Loading:
            return __assign(__assign({}, state), { loaded: false, loading: true, failed: true });
        case ActionTypes.Failed:
            return __assign(__assign({}, state), { loaded: false, loading: false, failed: true });
        case ActionTypes.Loaded:
            return __assign(__assign({}, state), { loaded: true, loading: false, failed: false, language: action.payload.locale, translations: action.payload.translations });
        default:
            return state;
    }
}
var asyncActionHandlers = {
    CHANGE_LANGUAGE: function (_a) {
        var dispatch = _a.dispatch;
        return function (action) { return __awaiter(void 0, void 0, void 0, function () {
            var translations, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(action.payload.localeBaseUrl && action.payload.locale))
                            return [2 /*return*/];
                        dispatch({ type: ActionTypes.Loading });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        log('loading translation for %s language from %s url', action.payload.locale, action.payload.localeBaseUrl);
                        return [4 /*yield*/, getTranslations(action.payload.localeBaseUrl, action.payload.locale)];
                    case 2:
                        translations = _a.sent();
                        log('Successfully loaded translation %o', translations);
                        dispatch({
                            type: ActionTypes.Loaded,
                            payload: { translations: translations, locale: action.payload.locale },
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        log('Failed to load translation');
                        dispatch({
                            type: ActionTypes.Failed,
                            payload: { error: error_1 },
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    },
};
function useTranslations(locale, localeBaseUrl) {
    var _a = __read(useReducerAsync(reducer, initialState, asyncActionHandlers), 2), state = _a[0], dispatch = _a[1];
    var changeLanguage = useCallback(function () {
        log('changing language to %s', locale);
        dispatch({ type: ActionTypes.ChangeLanguage, payload: { locale: locale, localeBaseUrl: localeBaseUrl } });
    }, [dispatch, locale, localeBaseUrl]);
    useEffect(changeLanguage, [changeLanguage]);
    return {
        translations: state.translations,
        loaded: state.loaded,
        loading: state.loading,
        failed: state.failed,
    };
}
export default useTranslations;
//# sourceMappingURL=useTranslations.js.map